import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default class MetaVacancyBox {
  constructor() {
    this.$metaNavElement = $('#header-secondary-outer .vacancies a');
    this.$body = $('body');

    this.date = null;
    if (window.metaTelBox) {
      this.data = JSON.parse(window.metaTelBox);
    }
    this.content = '';
  }

  init() {
    const self = this;
    if (!this.data.metaVacancy) {
      return;
    }

    self.content = self.data.metaVacancy;
    // mobile/desktop
    if (window.innerWidth <= 690) {
      // self.overlay();
    } else {
      self.tooltip();
    }
  }

  tooltip() {
    this.$metaNavElement.addClass('has-dropdown');
    this.$metaNavElement.append('<i class="fas fa-caret-down"></i>');

    tippy(this.$metaNavElement[0], {
      content: this.content,
      allowHTML: true,
      interactive: true,
      placement: 'bottom-end',
      boundary: 'viewport',
      theme: 'facta',
      arrow: false,
      maxWidth: 'none',
      // trigger: 'click', // for styling the tippy content.
    });
  }
}
